import styled, { css } from 'styled-components';

const Form = styled.form`
  ${({ $horizontal }) => $horizontal && css`
    display: inline-flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
    > * {
      flex-grow: 1;
    }
  `}
`;

export default Form;
